import { isMobile } from '../../../../core/helpers/isMobile';
import { isPG } from '../../../../core/helpers/skinHelper';
import { partnerSkinNames } from '../../../../core/constants/partnerSkinEnums';

export const DriftCanvasConfigMobile = {
  antialias: true,
  backgroundAlpha: 0,
  width: 350,
  height: 365,
};

export const DriftCanvasConfigWeb = {
  antialias: true,
  backgroundAlpha: 0,
  width: 1027,
  height: 680,
};

export const DRIFT_DEFAULT_TIMER_VALUE = 5;
export const DRIFT_GAME_ID = 50;

export const webWinAmountConfigs = {
  riderPosition: { x: 0, y: 0 },
  winAmountStyle: {
    fill: 0xffffff,
    fontSize: 50,
    fontWeight: 400,
    fontFamily: 'Poppins',
    align: 'centre',
    dropShadow: true,
    dropShadowBlur: 5,
    dropShadowDistance: 5,
  },
  containerColor: 0x000000,
  containerBorderColor: 0x696969,
  cashOutContainerColor: 0x282828,
  cashOutBorderColor: 0x000000,
  containerHeight: 120,
  containerBorderRadius: 10,
  defaultContainerPositions: { x: 450, y: 225 },
  pgDefaultWinAmountPositions: { x: 430, y: 288 },
  defaultWinAmountPositions: { x: 400, y: 288 },
  defaultCurrencyPositions: { x: 335, y: 288 },
  singleElementWidth: 24,
};

export const mobileWinAmountConfigs = {
  riderPosition: { x: 0, y: 0 },
  winAmountStyle: {
    fill: 0xffffff,
    fontSize: 20,
    fontFamily: 'Poppins',
    fontWeight: 500,
    align: 'centre',
    dropShadow: true,
    dropShadowBlur: 5,
    dropShadowDistance: 5,
  },
  containerColor: 0x000000,
  containerBorderColor: 0x696969,
  cashOutContainerColor: 0x282828,
  cashOutBorderColor: 0x000000,
  containerHeight: 60,
  containerBorderRadius: 6,
  defaultContainerPositions: { x: 170, y: 70 },
  pgDefaultWinAmountPositions: { x: 150, y: 105 },
  defaultWinAmountPositions: { x: 130, y: 105 },
  defaultCurrencyPositions: { x: 100, y: 103 },
  singleElementWidth: 11,
};

export const driftResourcesNames = {
  background: 'background',
  smoke: 'smoke',
  rider: 'rider',
};

export const betStatus = {
  lose: 0,
  win: 1,
  onHold: 7,
};

export const driftAnimationNames = {
  riderBet: 'bet',
  riderIdle: 'idle',
  idleDefault: 'idle2',
  riderLose: 'loose',
  smokeBet: 'bet',
  smokeIdle: 'idle',
};

export const gameResources = (partnerSkin) => {
  const animFileName = partnerSkinNames[partnerSkin];
  const driftWebAnimationSources = {
    background: {
      name: driftResourcesNames.background,
      path: `animations/drift_${animFileName}/web/web_bg.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/drift_${animFileName}/web/web_bg.atlas`,
        },
      },
    },
    smoke: {
      name: driftResourcesNames.smoke,
      path: `animations/drift_${animFileName}/web/web_wheelFX.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/drift_${animFileName}/web/web_wheelFX.atlas`,
        },
      },
    },
    rider: {
      name: driftResourcesNames.rider,
      path: `animations/drift_${animFileName}/web/web_rider_girl.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/drift_${animFileName}/web/web_rider_girl.atlas`,
        },
      },
    },
  };
  const driftMobileAnimationSources = {
    background: {
      name: driftResourcesNames.background,
      path: `animations/drift_${animFileName}/mobile/mob_bg.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/drift_${animFileName}/mobile/mob_bg.atlas`,
        },
      },
    },
    smoke: {
      name: driftResourcesNames.smoke,
      path: `animations/drift_${animFileName}/mobile/mob_wheelFX.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/drift_${animFileName}/mobile/mob_wheelFX.atlas`,
        },
      },
    },
    rider: {
      name: driftResourcesNames.rider,
      path: `animations/drift_${animFileName}/mobile/mob_rider_girl.json`,
      config: {
        metadata: {
          spineAtlasFile: `animations/drift_${animFileName}/mobile/mob_rider_girl.atlas`,
        },
      },
    },
  };
  return [...Object.values(isMobile() ? driftMobileAnimationSources : driftWebAnimationSources)];
};

export const DRIFT_RULES_KEYS = new Array(isPG() ? 14 : 9)
  .fill(null)
  .map((item, index) => index + 1);
export const DRIFT_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
